import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import Iconify from "../../components/Iconify";
import Reveal from "../../components/Reveal";
import { BeltStripe } from "../../theme/brand";
import { PRICE_TIERS, CONDITIONS } from "./content";

export default function Pricing() {
  return (
    <Box
      id="preise"
      sx={{ py: { xs: 8, md: 12 }, bgcolor: "grey.50", scrollMarginTop: { xs: 56, md: 72 } }}
    >
      <Container maxWidth="md">
        <Stack spacing={1} sx={{ mb: 5, textAlign: "center" }}>
          <Typography variant="overline" sx={{ color: "primary.main", fontWeight: 700, letterSpacing: 2 }}>
            Preise
          </Typography>
          <Typography variant="h3" component="h2" fontWeight={800} letterSpacing="-0.02em">
            Wächst mit deiner Schule
          </Typography>
          <Typography sx={{ color: "grey.600" }}>
            Du zahlst nur nach Mitgliederzahl – alle Funktionen sind immer
            enthalten.
          </Typography>
        </Stack>

        <Reveal
          sx={{
            bgcolor: "#fff",
            border: "1px solid",
            borderColor: "grey.200",
            borderRadius: 3,
            overflow: "hidden",
            maxWidth: 540,
            mx: "auto",
            boxShadow: "0 16px 48px rgba(18,16,31,0.07)",
          }}
        >
          <BeltStripe height={4} />
          {PRICE_TIERS.map((tier, i) => (
            <Stack
              key={tier.label}
              direction="row"
              justifyContent="space-between"
              alignItems="baseline"
              sx={{
                px: 3.5,
                py: 2,
                borderBottom: i < PRICE_TIERS.length - 1 ? "1px solid" : "none",
                borderColor: "grey.100",
              }}
            >
              <Typography sx={{ color: "grey.700" }}>{tier.label}</Typography>
              <Typography fontWeight={800} fontSize={18}>
                {tier.price}
                <Typography component="span" variant="caption" sx={{ color: "grey.500", ml: 0.5, fontWeight: 500 }}>
                  / Monat
                </Typography>
              </Typography>
            </Stack>
          ))}
          <Box sx={{ px: 3.5, py: 1.5, bgcolor: "grey.50" }}>
            <Typography variant="caption" sx={{ color: "grey.500" }}>
              Alle Preise zzgl. 19 % MwSt.
            </Typography>
          </Box>
        </Reveal>

        <Stack spacing={1.25} sx={{ mt: 4, maxWidth: 540, mx: "auto" }}>
          {CONDITIONS.map((c) => (
            <Stack direction="row" spacing={1.5} alignItems="center" key={c}>
              <Iconify icon="mdi:check" width={18} sx={{ color: "primary.main", flexShrink: 0 }} />
              <Typography variant="body2" sx={{ color: "grey.700" }}>
                {c}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Container>
    </Box>
  );
}
